jQuery(document).ready( function($) {
  $('a').each(function() {
    var isSocial = $(this).hasClass('social-sharer-button');
    if(isSocial) {

      var description = $("meta[property='og:description']").attr("content");
      var socialmediastring = '';

      switch( $(this).data("social") ) {
        case 'facebook':
                      socialmediastring.concat('https://www.facebook.com/sharer.php?u=');
                      socialmediastring.concat(localized.getpermalink);
                      break;
        case 'twitter':
                      socialmediastring.concat('https://twitter.com/intent/tweet');
                      socialmediastring.concat(localized.getpermalink);
                      if(description != null) {
                        socialmediastring.concat('&text=' + description);
                      }
                      socialmediastring.concat('&via=' + $("meta[property='og:site_name']").attr("content"));
                      break;
        case 'email':
                     socialmediastring.concat('mailto:');
                     if(description != null) {
                       socialmediastring.concat('?subject=' + description);
                     }
                     break;
      }
      $(this).attr('href', socialmediastring);
    }
});
})
